import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { SHARED_ENVIRONMENT } from '@cp/shared/environment/environment.token';
import { Environment } from '@cp/shared/environment/environment.interface';

@Component({
  selector: 'cp-log-out',
  template: '<ui-progress-spinner></ui-progress-spinner>',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogOutComponent implements OnInit {
  constructor(
    private _authService: AuthService,
    @Inject(SHARED_ENVIRONMENT) private _environment: Environment,
  ) {}

  public ngOnInit(): void {
    this._authService.logout({
      logoutParams: {
        returnTo: this._environment.auth0.logoutUrl,
      },
    });
  }
}
